import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  type?: "website" | "article";
  image?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  canonical = "https://skystanoyevitch.com",
  type = "website",
  image = "https://skystanoyevitch.com/og-image.jpg",
}) => {
  const fullTitle = title.includes("Sky Stanoyevitch")
    ? title
    : `${title} | Sky Stanoyevitch`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Person",
          name: "Sky Stanoyevitch",
          jobTitle: "React Native iOS Developer",
          url: "https://skystanoyevitch.com",
          sameAs: ["https://github.com/skystanoyevitch"],
          knowsAbout: [
            "React Native",
            "iOS Development",
            "TypeScript",
            "Expo",
            "Mobile App Development",
            "Offline-First Architecture",
          ],
          description:
            "React Native iOS developer specializing in mobile apps with offline-first architecture, privacy-focused design, and polished user experiences.",
        })}
      </script>
    </Helmet>
  );
};
